import React from 'react';
import {
  ContextualMenu,
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  Icon,
  PrimaryButton,
  Text,
  useTheme,
} from '@fluentui/react';
import { Image, ImageFit } from '@fluentui/react/lib/Image';

interface IPlanillaDigitalEventButtons {
  hasStarted: boolean;
  key: number;
  value: string;
  imageSrc: string;
  tipoEventoSelected: string;
  esDiferido: boolean;
  onRefereeReview: boolean;
  setTipoEventoSelected: (v: string) => void;
}

export const PlanillaDigitalEventButtons = (props: IPlanillaDigitalEventButtons) => {
  const isActive = React.useMemo(
    () => props.tipoEventoSelected === props.value,
    [props.tipoEventoSelected, props.value]
  );
  const [openErrorModal, setOpenErrorModal] = React.useState<boolean>(false);

  const handleClick = () => {
    const canAddEvents = props.hasStarted || props.esDiferido || props.onRefereeReview;
    if (!isActive && canAddEvents) {
      props.setTipoEventoSelected(props.value);
    } else if (!canAddEvents) {
      setOpenErrorModal(true);
    }
  };

  const theme = useTheme();
  return (
    <>
      <PrimaryButton
        onClick={handleClick}
        styles={{
          root: {
            border: '1px solid ' + theme.palette.neutralQuaternary,
            width: '100%',
            height: '80px',
            margin: '5px 0',
            backgroundColor: isActive ? theme.palette.themeTertiary : 'transparent',
            outline: 'none',
          },
          label: {
            maxWidth: '100%',
            maxHeight: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
        }}
        className="ms-depth-4"
        value={props.value}
        title={props.value}
      >
        <Image
          src={props.imageSrc}
          alt={`Button ${props.value}`}
          imageFit={ImageFit.center}
          styles={{ image: { maxWidth: '65%', maxHeight: '65%' }, root: { width: '100%', height: '100%' } }}
          title={props.value}
        />
      </PrimaryButton>
      <Dialog
        hidden={!openErrorModal}
        onDismiss={() => setOpenErrorModal(!openErrorModal)}
        dialogContentProps={{
          type: DialogType.largeHeader,
          title: (
            <div>
              <Icon iconName="StatusErrorFull" style={{ position: 'relative', top: '3px' }} /> Atención
            </div>
          ),
          styles: {
            header: {
              background: '#ff4848',
            },
            title: {
              color: 'white',
            },
            content: {
              borderTop: '4px solid #ff4848',
            },
          },
        }}
        modalProps={{
          isBlocking: true,
          dragOptions: {
            moveMenuItemText: 'Move',
            closeMenuItemText: 'Close',
            menu: ContextualMenu,
          },
        }}
        minWidth={600}
        // className="ms-motion-scaleDownIn"
        className={openErrorModal ? 'ms-motion-scaleDownIn' : 'ms-motion-scaleDownOut'}
      >
        <div className="mt-2 text-center">
          <Text variant="xLarge" style={{ fontWeight: 600, fontSize: 30 }}>
            El partido debe haber empezado para empezar a asignar eventos
          </Text>
        </div>

        <DialogFooter>
          <DefaultButton onClick={() => setOpenErrorModal(!openErrorModal)} text={'Listo'} />
        </DialogFooter>
      </Dialog>
    </>
  );
};

export default PlanillaDigitalEventButtons;
